/**
 * Route locale for a news item (Navatelanga Telugu-only: `te-IN`).
 * When `articleLanguage` is set, use it so links match the article's site (cross-locale related news).
 * Otherwise use `fallbackLocale` (typically from the current pathname).
 */
export function localeFromNewsLanguage(
  articleLanguage: string | null | undefined,
  fallbackLocale: string,
): string {
  if (articleLanguage == null || String(articleLanguage).trim() === "") {
    // return fallbackLocale || "en-IN";
    return fallbackLocale || "te-IN";
  }
  const code = String(articleLanguage).split("-")[0].toLowerCase();
  // return code === "te" ? "te-IN" : "en-IN";
  return code === "te" ? "te-IN" : "te-IN";
}
